'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SEND_LOADED: 'SEND_LOADED',

  SEND_REDIRECT: 'SEND_REDIRECT',

  GET_DIMENSIONS: 'GET_DIMENSIONS',
  SEND_DIMENSIONS: 'SEND_DIMENSIONS'
};
module.exports = exports['default'];